<template>

    <div class="content-overlay n-content">

        <div class="in-content" :class="{ clsng : Global.tempClosingOverlay }">

            <div class="head">
                <h5>
                    <span class="txt-grt">Add new content</span>
                    <span class="steps">{{ currentStep }}/3</span>
                </h5>
                <span class="x" @click.prevent="closeContentOverlay">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M19.4706 2.5L2.5 19.4706" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    <path d="M19.4706 19.4706L2.5 2.5" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    </svg>
                </span>
            </div>

            <div class="inner-content">

                <!-- STEPS -->

                <div class="lft">
                    <!-- <NewContentOne></NewContentOne> -->
                    <transition
                    name="fade"
                    mode="out-in">
                        <keep-alive max="3">
                            <NewContentOne v-if="currentStep == 1" @nxt="goTo(2)"></NewContentOne>
                            <NewContentTwo v-if="currentStep == 2" @prv="goTo(1)" @nxt="goTo(3)"></NewContentTwo>
                            <NewContentThree v-if="currentStep == 3" @prv="goTo(2)"></NewContentThree>
                        </keep-alive>
                    </transition>
                </div>

                <!-- PREVIEW -->

                <div class="col rgt">
                    <p class="step-caption ft-bld">Preview of your content</p>
                    <div class="card-preview"  :class="['radius' + Global.mockupConfig.radiusRatio, Global.mockupConfig.activeFont]">
                        <div class="top" :style="placeholderBg">
                            <div class="pic cvr no-pointer" :style="{backgroundImage: 'url('+Global.newContentOverlay.poster+')'}"></div>
                            <div class="infos col">
                                <div class="ft-bld p-tag" :style="{ backgroundColor : Global.mockupConfig.colors.icons }">{{ Global.plans[Global.newContentOverlay.planIndex].name }}</div>
                                <span class="ft-xbld p-title">{{ Global.newContentOverlay.name || "Content name" }}</span>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="actions">
                                <div class="btn main ply" :style="{ background : Global.mockupConfig.colors.icons }" :class="{ 'sub' : Global.newContentOverlay.planIndex !== 0 }">
                                    <span class="ico">
                                        <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                                        </svg>
                                    </span>
                                    <span class="txt">{{ Global.newContentOverlay.planIndex !== 0 ? "Subscribe" : "Play"}}</span>
                                </div>
                                <div class="sqr i">
                                    <span class="ico">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                        <circle cx="13" cy="13" r="13" fill="white"/>
                                        <circle cx="13" cy="7" r="2" fill="#696969"/>
                                        <path d="M13 12V19" stroke="#696969" stroke-width="3" stroke-linecap="round"/>
                                        </svg>
                                    </span>
                                </div> 
                                <div class="sqr add">
                                    <span class="ico">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                        <path d="M13 2V24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M2 13H24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div> 
                                <div class="sqr vol">
                                    <span class="ico">
                                        <svg width="29" height="23" viewBox="0 0 29 23" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91872H3.33333C2.59733 6.91872 2 7.51605 2 8.25205V14.5854C2 15.3214 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4134C12.672 21.1481 14 20.5321 14 19.3961V3.44138C14 2.30538 12.6707 1.68938 11.8053 2.42405L6.5 6.91872Z" fill="white" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M19.3828 16.7226C20.9321 15.76 22.0001 13.7573 22.0001 11.4253C22.0001 9.09329 20.9321 7.08929 19.3828 6.11462" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M23.3407 20.8387C25.7513 18.7653 27.334 15.3253 27.334 11.4227C27.334 7.51467 25.7487 4.072 23.334 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div> 
                            </div>
                            <!-- <p class="sum">An original series born out of James Franco's love for movies, with a twist. Each episode will feature Franco and one or more fellow artists remaking classic television shows and movie scenes, reimagining old and cult classics by swapping genres, characters and more.</p> -->
                            <p class="sum">{{ Global.newContentOverlay.description || "Content description" }}</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'
    import NewContentOne from '../components/contents/NewContentOne'
    import NewContentTwo from '../components/contents/NewContentTwo'
    import NewContentThree from '../components/contents/NewContentThree'

    export default {

        name: 'ContentOverlay',

        components: {
            NewContentOne,
            NewContentTwo,
            NewContentThree
        },

        props: {
            
        },

        data() {
            return {
                Global,
                currentStep: 1
            }
        },

        computed: {
            placeholderBg() {
                return { background: this.hexToRGB(this.Global.mockupConfig.colors.icons,.1) }
            },
        },

        mounted() {
            if(this.Global.returnToContent == true) {
                this.Global.returnToContent = false
                this.currentStep = 3
            }
        },

        methods: {

            goTo(num) {
                this.currentStep = num
            },

            closeContentOverlay() {
                return new Promise((resolve) => {
                    this.Global.tempClosingOverlay = true
                    setTimeout(() => { this.Global.activeBlurredOverlay = false }, 300)
                    setTimeout(() => { 
                        this.Global.activeContentOverlay = false 
                        resolve()
                    }, 600)
                })
            },

            adjust(color, amount) {
                return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
            },

            hexToRGB(hex, alpha) {
                let r = parseInt(hex.slice(1, 3), 16),
                    g = parseInt(hex.slice(3, 5), 16),
                    b = parseInt(hex.slice(5, 7), 16);
                if (alpha)
                    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
                else
                    return "rgb(" + r + ", " + g + ", " + b + ")";
            }

        }
    }
</script>